import { createFileRoute } from '@tanstack/react-router';
import { CookiePolicyPage } from '~/components/pages/CookiePolicyPage';
import { pageHeadMeta } from '~/lib/seo';
import readingStylesHref from '~/styles/reading.css?url';

export const Route = createFileRoute('/terms/cookie')({
  head: () =>
    pageHeadMeta({
      title: 'Cookie Policy – nsave',
      description:
        'How nsave uses cookies and similar technologies on the website, and how you can control them.',
      path: '/terms/cookie',
      stylesheets: [readingStylesHref],
    }),
  component: CookiePolicyPage,
});
